
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 945.4 143.8","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_399","transform":"translate(-228.69 -687.619)"}},[_c('path',{staticClass:"st0",attrs:{"d":"M792.1 781.9l-157.6-15.7-170.8 12.3H238v-1h225.7l170.8-12.3 157.6 15.7 188.2-31 84.2 15.2 109.4-27.7.2.9-109.6 27.9-84.2-15.3z","id":"Path_642"}}),_c('path',{staticClass:"st0",attrs:{"d":"M563.7 788.1l-.1-.1-62.7-10.3-156.5-25.4-115.7-39.8.3-1 115.6 39.9 156.5 25.3 62.5 10.3 110-50.2h.2l103.4 14.5L898 687.6l.2.2 105.8 63.5 161.2-63.6.3 1-161.6 63.7-.2-.1L898 688.8l-120.6 63.5h-.2l-103.4-14.5z","id":"Path_643"}}),_c('path',{staticClass:"st0",attrs:{"d":"M238.2 831.4l-.4-.8L370.9 762h.2l221 25.9 142.4-60.2.2.1 104.8 60.1 169.5-76.1.3.4 54 75.6 101.8-60 .5.9-102.6 60.4-.2-.4-54.1-75.6L839.5 789l-105.1-60.2L592.3 789l-.2-.1-221-25.9z","id":"Path_644"}}),_c('circle',{staticClass:"st0",attrs:{"id":"Ellipse_22","cx":"285.5","cy":"744.5","r":"6.5"}}),_c('circle',{staticClass:"st0",attrs:{"id":"Ellipse_23","cx":"404.5","cy":"794.5","r":"6.5"}}),_c('circle',{staticClass:"st0",attrs:{"id":"Ellipse_24","cx":"612.5","cy":"751.5","r":"6.5"}}),_c('circle',{staticClass:"st0",attrs:{"id":"Ellipse_25","cx":"749.5","cy":"766.5","r":"6.5"}}),_c('circle',{staticClass:"st0",attrs:{"id":"Ellipse_26","cx":"919.5","cy":"722.5","r":"6.5"}}),_c('circle',{staticClass:"st0",attrs:{"id":"Ellipse_27","cx":"1037.5","cy":"760.5","r":"6.5"}}),_c('circle',{staticClass:"st0",attrs:{"id":"Ellipse_28","cx":"1125.5","cy":"705.5","r":"6.5"}})])])
          )
        }
      }
    